import React from 'react';
import ReactLoadingSkeleton, {
	SkeletonProps as ReactLoadingSkeletonProps,
} from 'react-loading-skeleton';
import classNames from 'classnames';
import styles from './UserFacetSkeletonLoader.module.scss';

interface CustomProps {
	childrenContainerClassName?: string;
	skeletonContainerStyle?: React.CSSProperties;
	dataLoading: boolean;
}

export const Skeleton: React.FC<ReactLoadingSkeletonProps & CustomProps> = ({
	children,
	...props
}) => {
	return props.dataLoading ? (
		<div style={{ width: '100%', ...props.skeletonContainerStyle }}>
			<ReactLoadingSkeleton {...props} />
		</div>
	) : (
		<div className={classNames(styles.animatedChild, props.childrenContainerClassName)}>
			{children}
		</div>
	);
};
